const ICONS_CONFIG_BY_NAME: Record<IconName, IconConfig> = {
  angleLeft: {
    paths: [
      {
        shape:
          'm7.27242 10.4336 7.08258 7.079-1.1046 1.1052-7.11929-7.1158c-.64728-.583-.64616-1.55928.00335-2.14093l7.12144-6.97885 1.0936 1.11597z',
        clipRule: 'evenodd',
        fillRule: 'evenodd',
      },
    ],
    width: '20',
    height: '21',
  },
  angleRight: {
    paths: [
      {
        shape:
          'm10.1827 8.05313-5.6661-5.66324.88366-.88411 5.69544 5.69262c.5179.46641.517 1.24743-.0027 1.71275l-5.69712 5.58305-.8749-.8927z',
        clipRule: 'evenodd',
      },
    ],
    width: '16',
    height: '16',
  },
  appLogo: {
    paths: [
      {
        shape:
          'M16.6612 0.5H16.6512C16.6512 0.5 16.6448 0.5 16.6411 0.5C14.2922 0.503649 12.0545 1.425 10.3842 3.04967C9.52945 2.6866 8.60811 2.49959 7.65666 2.49959C3.79612 2.49959 0.65625 5.63947 0.65625 9.5C0.65625 13.3605 3.79612 16.4995 7.65574 16.4995C8.5926 16.4995 9.51942 16.3088 10.376 15.9476C11.9979 17.5248 14.2101 18.5 16.6457 18.5C21.6082 18.5 25.6457 14.4625 25.6457 9.5C25.6457 4.5375 21.6164 0.507298 16.6612 0.5ZM16.6457 16.4995C12.7861 16.4995 9.64622 13.3596 9.64622 9.5H7.64662C7.64662 11.2652 8.15929 12.9117 9.0405 14.3029C8.5926 14.4315 8.12645 14.4999 7.65574 14.4999C4.899 14.4999 2.65584 12.2577 2.65584 9.5C2.65584 6.74235 4.89809 4.5001 7.65574 4.5001C8.74768 4.5001 9.78487 4.84492 10.6551 5.49899C11.9268 6.45408 12.6556 7.91273 12.6556 9.5H14.6552C14.6552 7.40553 13.7485 5.47253 12.1557 4.13795C13.4073 3.08798 14.9937 2.50142 16.6503 2.49959C20.5081 2.50233 23.6452 5.64129 23.6452 9.49909C23.6452 13.3569 20.5053 16.4995 16.6457 16.4995Z',
      },
      {
        shape:
          'M32.5987 14.456H30.6958V6.41752H32.5987V7.48391C33.1068 6.71308 33.9278 6.22048 35.059 6.22048C37.0275 6.22048 38.176 7.51675 38.176 9.61577V14.4551H36.2731V9.97701C36.2731 8.73 35.6501 7.97559 34.4852 7.97559C33.3203 7.97559 32.5987 8.84494 32.5987 10.2233V14.456Z',
      },
      {
        shape:
          'M39.5161 10.9942V6.41754H41.419V10.8792C41.419 12.1427 42.042 12.8971 43.092 12.8971C44.142 12.8971 44.765 12.1427 44.765 10.8792V6.41754H46.6679V10.9942C46.6679 13.3067 45.3224 14.6522 43.092 14.6522C40.8616 14.6522 39.5161 13.3067 39.5161 10.9942Z',
      },
      {
        shape:
          'M47.2089 6.41754H49.2258L51.375 11.9949L53.5406 6.41754H55.5083L52.1951 14.4561H50.5221L47.2089 6.41754Z',
      },
      {
        shape:
          'M63.4291 10.4368C63.4291 8.02578 61.7725 6.2214 59.4272 6.2214C57.0818 6.2214 55.3422 8.02578 55.3422 10.4368C55.3422 12.8478 57.0809 14.6522 59.5257 14.6522C61.2315 14.6522 62.4785 13.8321 63.1508 12.5687L61.5928 11.8307C61.1339 12.5358 60.5921 13.0448 59.5421 13.0448C58.3444 13.0448 57.3108 12.1755 57.2287 11.0106H63.4136C63.43 10.7807 63.4291 10.5837 63.4291 10.4368ZM57.2451 9.63312C57.3765 8.71451 58.2623 7.77948 59.3943 7.77948C60.5264 7.77948 61.4122 8.56673 61.5435 9.63312H57.2451Z',
      },
      {
        shape:
          'M66.3099 14.456H64.407V6.41752H66.3099V7.48391C66.7533 6.71308 67.5077 6.22048 68.606 6.22048C69.7709 6.22048 70.6074 6.77785 71.0498 7.71287C71.4768 6.94205 72.3954 6.22048 73.7236 6.22048C75.5772 6.22048 76.6436 7.50033 76.6436 9.51725V14.4551H74.7407V9.87849C74.7407 8.69716 74.1997 7.95917 73.199 7.95917C72.1983 7.95917 71.4932 8.79568 71.4768 10.1084V14.4551H69.5739V9.94417C69.5739 8.69716 69.0329 7.95917 68.0322 7.95917C66.9822 7.95917 66.3099 8.8121 66.3099 10.1905V14.456Z',
      },
      {
        shape:
          'M82.085 6.38479C80.7887 6.38479 79.5098 7.07351 78.9515 8.10706V6.56541H77.9836V17.8679H78.9515V12.9464C79.5262 13.98 80.7559 14.6358 82.085 14.6358C84.3482 14.6358 86.1043 12.8315 86.1043 10.519C86.1043 8.2065 84.3491 6.38479 82.085 6.38479ZM82.0193 13.7337C80.2478 13.7337 78.8867 12.2905 78.8867 10.519C78.8867 8.74745 80.2478 7.28698 82.0193 7.28698C83.7908 7.28698 85.1035 8.68085 85.1035 10.519C85.1035 12.3571 83.7416 13.7337 82.0193 13.7337Z',
      },
      {
        shape:
          'M90.17 6.38479C88.6612 6.38479 87.4799 7.23772 87.0867 8.61609L88.0217 8.87881C88.3337 7.84526 89.0717 7.27147 90.1709 7.27147C91.418 7.27147 92.1724 7.97662 92.1724 9.17437V9.63413L89.5479 9.92969C87.7107 10.1267 86.8085 10.9961 86.8085 12.4228C86.8085 13.7191 87.8256 14.6377 89.318 14.6377C90.6134 14.6377 91.6633 14.0475 92.2052 13.1289V14.458H93.1402V9.24187C93.1402 7.45391 92.0574 6.38752 90.1709 6.38752L90.17 6.38479ZM92.1714 11.2077C92.1714 12.5852 91.0558 13.7501 89.4813 13.7501C88.497 13.7501 87.8083 13.1927 87.8083 12.3562C87.8083 11.5197 88.4642 10.9131 89.7112 10.7653L92.1714 10.4861V11.2077Z',
      },
      {
        shape:
          'M97.1239 15.8637C96.4671 17.4409 95.8094 18.0649 94.7093 18.0649C94.3973 18.0649 94.151 17.9992 93.9375 17.9171V17.014C94.1181 17.0961 94.3809 17.1618 94.66 17.1618C95.3661 17.1618 95.7775 16.7348 96.2208 15.6666L96.7791 14.3029L93.5261 6.56538H94.5943L97.2881 13.1699L99.9655 6.56538H101.001L97.1239 15.8637Z',
      },
    ],
    width: '101',
    height: '19',
  },
  camera: {
    paths: [
      {
        shape:
          'M8.85142 7.125H1.875V19.875H22.125V7.125H15.1486L14.3986 4.875H9.60142L8.85142 7.125ZM24 6.75V20.25C24 21.0784 23.3284 21.75 22.5 21.75H1.5C0.671573 21.75 0 21.0784 0 20.25V6.75C0 5.92157 0.671573 5.25 1.5 5.25H7.5L7.90811 4.02566C8.11229 3.41314 8.68549 3 9.33114 3H14.6689C15.3145 3 15.8877 3.41315 16.0919 4.02566L16.5 5.25H22.5C23.3284 5.25 24 5.92157 24 6.75Z',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        shape:
          'M14.075 13.5C14.075 12.5799 13.2363 11.625 11.95 11.625C10.6637 11.625 9.825 12.5799 9.825 13.5C9.825 14.4201 10.6637 15.375 11.95 15.375C13.2363 15.375 14.075 14.4201 14.075 13.5ZM15.95 13.5C15.95 11.4326 14.1564 9.75 11.95 9.75C9.7436 9.75 7.95 11.4326 7.95 13.5C7.95 15.5674 9.7436 17.25 11.95 17.25C14.1564 17.25 15.95 15.5674 15.95 13.5Z',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        shape:
          'M19.255 9C19.8066 9 20.255 9.42065 20.255 9.9375C20.255 10.4543 19.8066 10.875 19.255 10.875C18.7034 10.875 18.255 10.4543 18.255 9.9375C18.255 9.42065 18.7034 9 19.255 9Z',
      },
    ],
    width: '24',
    height: '24',
  },
  circle: {
    paths: [
      {
        shape:
          'M9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM9 15C5.6925 15 3 12.3075 3 9C3 5.6925 5.6925 3 9 3C12.3075 3 15 5.6925 15 9C15 12.3075 12.3075 15 9 15Z',
      },
    ],
    width: '18',
    height: '18',
  },
  close: {
    paths: [
      {
        shape:
          'M18.2987 5.71C17.9087 5.32 17.2787 5.32 16.8887 5.71L11.9988 10.59L7.10875 5.7C6.71875 5.31 6.08875 5.31 5.69875 5.7C5.30875 6.09 5.30875 6.72 5.69875 7.11L10.5888 12L5.69875 16.89C5.30875 17.28 5.30875 17.91 5.69875 18.3C6.08875 18.69 6.71875 18.69 7.10875 18.3L11.9988 13.41L16.8887 18.3C17.2787 18.69 17.9087 18.69 18.2987 18.3C18.6887 17.91 18.6887 17.28 18.2987 16.89L13.4087 12L18.2987 7.11C18.6787 6.73 18.6787 6.09 18.2987 5.71V5.71Z',
      },
    ],
    width: '20',
    height: '20',
  },
  ellipsisVertical: {
    paths: [
      {
        shape:
          'M10 3.125C10.8619 3.125 11.5625 3.78147 11.5625 4.58807C11.5625 5.39467 10.8619 6.05114 10 6.05114C9.13813 6.05114 8.4375 5.39467 8.4375 4.58807C8.4375 3.78147 9.13813 3.125 10 3.125Z',
      },
      {
        shape:
          'M10 13.9489C10.8619 13.9489 11.5625 14.6053 11.5625 15.4119C11.5625 16.2185 10.8619 16.875 10 16.875C9.13813 16.875 8.4375 16.2185 8.4375 15.4119C8.4375 14.6053 9.13813 13.9489 10 13.9489Z',
      },
      {
        shape:
          'M10 8.53694C10.8619 8.53694 11.5625 9.19341 11.5625 10C11.5625 10.8066 10.8619 11.4631 10 11.4631C9.13813 11.4631 8.4375 10.8066 8.4375 10C8.4375 9.19341 9.13813 8.53694 10 8.53694Z',
      },
    ],
    width: '20',
    height: '20',
  },
  external: {
    paths: [
      {
        shape: 'M17.6233 2.9231L9.95919 9.53247L9.0408 8.46753L16.7049 1.85815L17.6233 2.9231Z',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        shape:
          'M16.4844 3.09375H11.75V1.6875H16.4844C17.2852 1.6875 17.9375 2.33973 17.9375 3.14058V7.875H16.5312V3.14058C16.5312 3.1299 16.5275 3.11875 16.5169 3.10812C16.5063 3.0975 16.4951 3.09375 16.4844 3.09375Z',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        shape:
          'M8.9375 3.9375H2.1875C1.56618 3.9375 1.0625 4.44118 1.0625 5.0625V15.1875C1.0625 15.8088 1.56618 16.3125 2.1875 16.3125H14.5625C15.1838 16.3125 15.6875 15.8088 15.6875 15.1875V10.6875H14.2812V14.9062H2.46875V5.34375H8.9375V3.9375Z',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
    ],
    width: '19',
    height: '18',
  },
  filledCircle: {
    paths: [
      {
        shape:
          'M9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM9 15C5.6925 15 3 12.3075 3 9C3 5.6925 5.6925 3 9 3C12.3075 3 15 5.6925 15 9C15 12.3075 12.3075 15 9 15Z',
      },
      {
        shape:
          'M13.5 9C13.5 11.4853 11.4853 13.5 9 13.5C6.51472 13.5 4.5 11.4853 4.5 9C4.5 6.51472 6.51472 4.5 9 4.5C11.4853 4.5 13.5 6.51472 13.5 9Z',
      },
    ],
    width: '18',
    height: '18',
  },
  lock: {
    paths: [
      {
        shape:
          'M7.25 12.2022V13.6222H8.75V12.2022C9.00122 12.0841 9.21415 11.8976 9.36446 11.6642C9.51476 11.4308 9.59639 11.1598 9.6 10.8822C9.59354 10.6786 9.54702 10.4783 9.46309 10.2927C9.37917 10.1072 9.25948 9.93992 9.11089 9.80061C8.96229 9.66131 8.7877 9.55265 8.59708 9.48086C8.40647 9.40907 8.20358 9.37556 8 9.38223C7.79642 9.37556 7.59353 9.40907 7.40292 9.48086C7.2123 9.55265 7.03771 9.66131 6.88911 9.80061C6.74052 9.93992 6.62083 10.1072 6.53691 10.2927C6.45298 10.4783 6.40646 10.6786 6.4 10.8822C6.40362 11.1598 6.48524 11.4308 6.63554 11.6642C6.78585 11.8976 6.99878 12.0841 7.25 12.2022Z',
      },
      {
        shape:
          'M14.75 6.00223H13.5C13.4249 4.61302 12.8056 3.30931 11.7761 2.37346C10.7467 1.43762 9.39006 0.944972 8 1.00223C6.60994 0.944972 5.25328 1.43762 4.22385 2.37346C3.19442 3.30931 2.57509 4.61302 2.5 6.00223H1.25C0.918479 6.00223 0.600537 6.13392 0.366117 6.36834C0.131696 6.60277 0 6.92071 0 7.25223V15.7522C0 16.0837 0.131696 16.4017 0.366117 16.6361C0.600537 16.8705 0.918479 17.0022 1.25 17.0022H14.75C15.0815 17.0022 15.3995 16.8705 15.6339 16.6361C15.8683 16.4017 16 16.0837 16 15.7522V7.25223C16 6.92071 15.8683 6.60277 15.6339 6.36834C15.3995 6.13392 15.0815 6.00223 14.75 6.00223ZM8 2.25223C9.05815 2.1971 10.0958 2.55885 10.8903 3.2599C11.6848 3.96095 12.1729 4.94545 12.25 6.00223H3.75C3.82705 4.94545 4.31519 3.96095 5.10971 3.2599C5.90423 2.55885 6.94185 2.1971 8 2.25223ZM14.75 15.7522H1.25V7.25223H14.75V15.7522Z',
      },
    ],
    width: '16',
    height: '18',
  },
  pinLocation: {
    paths: [
      {
        shape:
          'm9.99922.651891c-1.77891-.067764-3.51233.571259-4.82159 1.777459-1.30926 1.20621-2.08793 2.88155-2.16591 4.66004 0 6.25001 4.85 10.76251 6.4625 12.07501.14779.1219.33341.1886.525.1886.19158 0 .37718-.0667.52498-.1886 1.6125-1.3125 6.4625-5.7875 6.4625-12.07501-.078-1.77849-.8566-3.45383-2.1659-4.66004-1.3093-1.2062-3.0427-1.845223-4.82158-1.777459zm0 16.850009c-1.16156-1.0206-2.1942-2.1792-3.075-3.45-1.47378-2.0275-2.29364-4.45658-2.35-6.96251.07751-1.36419.69139-2.64236 1.70771-3.55564 1.01633-.91329 2.35261-1.38757 3.71729-1.31936 1.36468-.06821 2.70098.40607 3.71728 1.31936 1.0163.91328 1.6302 2.19145 1.7077 3.55564 0 5.10001-3.7 8.95001-5.42498 10.41251z',
      },
      {
        shape:
          'm9.99922 3.17791c-.45128-.01838-.90171.053-1.32519.21001-.42348.157-.81158.39651-1.14179.70464-.33022.30813-.59599.67874-.7819 1.09035s-.28826.85603-.30112 1.3075c.01451.45094.11797.89457.30445 1.30541.18647.41084.45228.78079.78215 1.08859.32987.30781.71731.5474 1.14006.70503.42275.15762.87247.23017 1.32334.21347.90758.027 1.78898-.30619 2.45178-.92682.6628-.62062 1.0531-1.47827 1.0857-2.38568-.0145-.44986-.1176-.89244-.3033-1.30243-.1857-.41-.4503-.77938-.7789-1.08702-.3285-.30764-.7145-.54751-1.1358-.7059-.4213-.15838-.8696-.23217-1.31948-.21715zm0 5.0625c-.4921.02731-.97496-.14153-1.34281-.46955-.36784-.32801-.59068-.78845-.61969-1.28045.02901-.492.25185-.95245.61969-1.28046.36785-.32802.85071-.49686 1.34281-.46954.49338-.02741.97758.14106 1.34748.46876.3698.3277.5953.78815.6275 1.28124-.0322.49308-.2577.95353-.6275 1.28123-.3699.32771-.8541.49617-1.34748.46877z',
      },
    ],
    width: '20',
    height: '20',
  },
  transferReal: {
    paths: [
      {
        shape:
          'M3.09375 6.72717V13.0411H4.65625V11.01H5.77178C6.84498 11.0652 7.69818 11.9529 7.69818 13.0398H9.26068C9.26068 12.086 8.88922 11.2189 8.28306 10.5754C8.79828 10.1843 9.131 9.56532 9.131 8.86861C9.131 7.68593 8.17225 6.72717 6.98956 6.72717H3.09375ZM5.80687 9.44755H6.98956C7.3093 9.44755 7.5685 9.18835 7.5685 8.86861C7.5685 8.54887 7.3093 8.28967 6.98956 8.28967H4.65625V9.44482H5.66569C5.71297 9.44482 5.76003 9.44574 5.80687 9.44755Z',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        shape:
          'M12.9213 5.13965H14.4838V6.70215H14.8839C15.9464 6.70215 16.8214 7.55215 16.8589 8.61465H15.2964C15.2589 8.41465 15.0838 8.26465 14.8839 8.26465H12.4964C12.2964 8.26465 12.1214 8.41465 12.0838 8.61465C12.0714 8.63965 12.0714 8.66465 12.0714 8.68965C12.0714 8.92715 12.2589 9.11465 12.4964 9.11465H14.9464C15.5589 9.11465 16.1213 9.40215 16.4839 9.85215C16.7589 10.1896 16.9214 10.6271 16.9088 11.0896V11.1396C16.8839 12.2021 16.0089 13.0646 14.9339 13.0646H14.4904V14.6287H12.9279V13.0646H12.5464C11.4713 13.0646 10.5963 12.2021 10.5714 11.1396H12.1463C12.1714 11.3396 12.3463 11.5021 12.5589 11.5021H14.9588C15.1714 11.5021 15.3463 11.3396 15.3714 11.1396V11.0896C15.3714 10.8521 15.1839 10.6646 14.9464 10.6646H12.4839C11.8714 10.6646 11.3089 10.3771 10.9464 9.92715C10.6714 9.58965 10.5089 9.16465 10.5089 8.68965V8.61465C10.5589 7.55215 11.4214 6.70215 12.4964 6.70215H12.9213V5.13965Z',
      },
      {
        shape:
          'M1.5625 1.875C0.699555 1.875 0 2.57456 0 3.4375V16.5625C0 17.4254 0.699555 18.125 1.5625 18.125H18.4375C19.3004 18.125 20 17.4254 20 16.5625V3.4375C20 2.57456 19.3004 1.875 18.4375 1.875H1.5625ZM18.4375 3.4375H1.5625V16.5625H18.4375V3.4375Z',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
    ],
    width: '20',
    height: '20',
  },
  truck: {
    paths: [
      {
        shape:
          'M6.3786 15.6353C6.3786 15.2141 5.97829 14.696 5.26917 14.696C4.56006 14.696 4.15975 15.2141 4.15975 15.6353C4.15975 16.0564 4.56006 16.5745 5.26917 16.5745C5.97829 16.5745 6.3786 16.0564 6.3786 15.6353ZM7.94394 15.6353C7.94394 14.2545 6.74458 13.1307 5.26917 13.1307C3.79377 13.1307 2.5944 14.2545 2.5944 15.6353C2.5944 17.016 3.79377 18.1398 5.26917 18.1398C6.74458 18.1398 7.94394 17.016 7.94394 15.6353Z',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        shape:
          'M11.0306 3.42553H2.19035L2.19035 14.0699H3.18252C2.81466 14.499 2.5944 15.0435 2.5944 15.6353H2.19035C1.32583 15.6353 0.625 14.9344 0.625 14.0699V3.42553C0.625 2.56101 1.32583 1.86018 2.19035 1.86018H11.0306C11.8951 1.86018 12.5959 2.56101 12.5959 3.42553V5.61702H15.1138C15.5624 5.61702 15.9894 5.80949 16.2865 6.14559L18.9824 9.19514C19.2354 9.48127 19.375 9.85001 19.375 10.2319V14.0699C19.375 14.9126 18.7091 15.5997 17.8749 15.6339C17.8745 15.0427 17.6543 14.4987 17.2867 14.0699H17.8097V10.7827H12.5959V14.0699H13.1134C12.7456 14.499 12.5253 15.0435 12.5253 15.6353H7.94394C7.94394 15.0435 7.72368 14.499 7.35583 14.0699H11.0254V7.18237C11.0254 7.13912 11.0271 7.09628 11.0306 7.05391V3.42553ZM16.9127 9.21732H12.5959V7.18237H15.1138L16.9127 9.21732Z',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
      {
        shape:
          'M16.3096 15.6353C16.3096 15.2141 15.9093 14.696 15.2001 14.696C14.491 14.696 14.0907 15.2141 14.0907 15.6353C14.0907 16.0564 14.491 16.5745 15.2001 16.5745C15.9093 16.5745 16.3096 16.0564 16.3096 15.6353ZM17.8749 15.6353C17.8749 14.2545 16.6756 13.1307 15.2001 13.1307C13.7247 13.1307 12.5253 14.2545 12.5253 15.6353C12.5253 17.016 13.7247 18.1398 15.2001 18.1398C16.6756 18.1398 17.8749 17.016 17.8749 15.6353Z',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
    ],
    width: '20',
    height: '20',
  },
  userCircle: {
    paths: [
      {
        shape:
          'm14.75 8c0 2.0523-1.0877 3.9185-2.7951 5.0668-.5016-1.6278-2.11086-2.7793-3.953-2.7793-1.84294 0-3.45281 1.1525-3.95368 2.7814-1.70922-1.1481-2.79822-3.0153-2.79822-5.0689 0-3.37701 2.94486-6.25 6.75-6.25 3.8051 0 6.75 2.87299 6.75 6.25zm-6.7481 3.5125c1.45409 0 2.6003.9595 2.8422 2.1596-.85866.3699-1.82024.5779-2.8441.5779-1.02247 0-1.98283-.2074-2.84063-.5764.24123-1.2008 1.38782-2.1611 2.84253-2.1611zm7.9981-3.5125c0 4.1421-3.5817 7.5-8 7.5-4.41828 0-8-3.3579-8-7.5 0-4.14214 3.58172-7.5 8-7.5 4.4183 0 8 3.35786 8 7.5zm-7.95-.15c-.47752 0-1-.43765-1-1.15s.52248-1.15 1-1.15 1 .43765 1 1.15-.52248 1.15-1 1.15zm0 1.25c-1.24264 0-2.25-1.07452-2.25-2.4s1.00736-2.4 2.25-2.4 2.25 1.07452 2.25 2.4-1.00736 2.4-2.25 2.4z',
        fillRule: 'evenodd',
        clipRule: 'evenodd',
      },
    ],
    width: '16',
    height: '16',
  },
};

export default ICONS_CONFIG_BY_NAME;
